import React, { useState, Fragment } from 'react';
import { isBlank, isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { find, propEq, pathOr } from 'ramda';
import { Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
// import Icon from 'sharedComponents/Icon';
import Chat from 'sharedComponents/Chat';
import LoanOfficersChatList from 'sharedComponents/LoanOfficersChatList';

import UserPresenter from 'presenters/UserPresenter';
import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import ChatPresenter, { buildChatCurrentUser } from 'presenters/ChatPresenter';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';

import { appRoutes } from 'routes';
import LoanOfficerBar from './components/LoanOfficerBar';
import BulkMessaging from './components/BulkMessaging';

import useStyles from './useStyles';

const DesktopMessages = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    isOnline,
    currentUser,
    onChatSelect,
    onMessageSend,
    onMessagesRead,
    selectedChatUid,
    chatsInfo,
    chats,
  } = props;

  const [showBulkMessagingPopup, setShowBulkMessagingPopup] = useState(false);

  const isChatSelected = isPresent(selectedChatUid);

  const { messages, isMessagesLoading, usersOnlineStatusList } = useFirebaseChat();
  const selectedChatMessages = messages[selectedChatUid];
  const selectedChat = find(propEq('uid', selectedChatUid), chats);
  const loanOfficerId = FirebaseChatPresenter.loanOfficerId(selectedChat);
  const isOnlineSelectedChatLoanOfficer = pathOr(false, [loanOfficerId, 'isOnline'], usersOnlineStatusList);
  const bid = FirebaseChatPresenter.latestBid(selectedChat);
  const selectedChatInfo = chatsInfo[selectedChatUid];
  const loanOfficer = isBlank(selectedChatInfo) ? null : ChatPresenter.loanOfficer(selectedChatInfo);
  const chatCurrentUser = buildChatCurrentUser(currentUser, isOnline);
  const chatParticipant = ChatPresenter.buildChatParticipantFromLoanOfficer(
    loanOfficerId,
    selectedChatInfo,
    isOnlineSelectedChatLoanOfficer,
  );

  // const handleBulkMessagingClick = () => setShowBulkMessagingPopup(true);

  const handleBulkMessageSend = (params, message) => {
    params.forEach(({ chatUid, participantId }) => onMessageSend(participantId, chatUid, message));
    setShowBulkMessagingPopup(false);
  };

  const handleBulkMessagingClose = () => setShowBulkMessagingPopup(false);

  return (
    <div className={classes.paper}>
      <div className={classes.loanOfficersBox}>
        <LoanOfficersChatList
          chatsInfo={chatsInfo}
          selectedChatUid={selectedChatUid}
          onChatSelect={onChatSelect}
          chats={chats}
        />
        <div className={classes.chatControlBar}>
          <Button
            to={appRoutes.surveyPath()}
            component={RouterLink}
            className={classes.controlButton}
            color="secondary"
          >
            {t('components.BuyerMessages.DesktopMessages.myMortgageInfo')}
          </Button>
          {/* <Button
            startIcon={<Icon name="message" />}
            className={classes.controlButton}
            onClick={handleBulkMessagingClick}
          >
            {t('components.BuyerMessages.DesktopMessages.bulkMessagingButton')}
          </Button> */}
        </div>
      </div>
      {isChatSelected ? (
        <Fragment>
          <div className={classes.chatBox}>
            <Chat
              chatCurrentUser={chatCurrentUser}
              isMessagesLoading={isMessagesLoading}
              messages={selectedChatMessages}
              chatParticipant={chatParticipant}
              chatUid={selectedChatUid}
              onMessageSend={onMessageSend}
              onMessagesRead={onMessagesRead}
            />
          </div>
          <div className={classes.loanOfficerInfoBox}>
            <LoanOfficerBar loanOfficer={loanOfficer} bid={bid} />
          </div>
        </Fragment>
      ) : (
        <div className={classes.emptyChatBox}>
          <Typography variant="subtitle1">{t('components.BuyerMessages.DesktopMessages.selectChat')}</Typography>
        </div>
      )}
      {showBulkMessagingPopup && (
        <BulkMessaging
          chats={chats}
          onBulkMessageSend={handleBulkMessageSend}
          onClose={handleBulkMessagingClose}
          currentUserId={currentUser.id}
          chatsInfo={chatsInfo}
        />
      )}
    </div>
  );
};

DesktopMessages.propTypes = {
  isOnline: PropTypes.bool.isRequired,
  currentUser: UserPresenter.shape().isRequired,
  onChatSelect: PropTypes.func.isRequired,
  onMessageSend: PropTypes.func.isRequired,
  onMessagesRead: PropTypes.func.isRequired,
  selectedChatUid: PropTypes.string,
  chats: PropTypes.arrayOf(FirebaseChatPresenter.shape()).isRequired,
  chatsInfo: PropTypes.shape().isRequired,
};

DesktopMessages.defaultProps = {
  selectedChatUid: null,
};

export default DesktopMessages;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/DesktopMessages/DesktopMessages.js